import { createContext } from 'react'

const BlockedModalContext = createContext()

export default BlockedModalContext
